import { useState } from "react";
import { useAuth } from "../hooks/Auth";

const ChangeProfilePic = ({ onClose }) => {
    const { token, updateSession, user } = useAuth();
    const [image, setImage] = useState(null);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const MAX_FILE_SIZE = 1024*1024
    const SUPPORTED_FILES = ["image/png", "image/webp", "image/jpeg"];

    const validate = () => {
        const newErrors = {};
        if (!image) newErrors.image = "An image file is required.";
        else{
            // Validate Image itself
            if(!SUPPORTED_FILES.includes(image.type)) newErrors.image = "Image Format not supported.\n.png or .jpeg allowed";
            if(image.size > MAX_FILE_SIZE) newErrors.image = "Image too large";
        }
        return newErrors;
    };

    const handleSubmit = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setSubmitting(true);

        try {
            //console.log("image:\t", image);
            const formData = new FormData();
            formData.append("profilePic", image);

            const accessToken = token?.access_token || token;
           
            const res = await fetch(`/api/gallery/profiles/${user?.id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            if (!res.ok) {
                const data = await res.json().catch(() => ({}));
                setErrors({ submit: data.error || "Failed to change profile picture." });
                return;
            }

            onClose();
        } catch (err) {
            setErrors({ submit: "Network error. Please try again." });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={onClose}>✕</button>
                <h2 style={{ marginTop: 0 }}>Change Profile Picture</h2>

                <div style={fieldStyle}>
                    <label>Image</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => setImage(e.target.files[0] || null)}
                    />
                    {errors.image && <span style={errorStyle}>{errors.image}</span>}
                </div>
                
                {errors.submit && <p style={errorStyle}>{errors.submit}</p>}

                <button
                    onClick={handleSubmit}
                    disabled={submitting}
                    style={{ marginTop: "1rem" }}
                >
                    {submitting ? "Changing..." : "Change Picture"}
                </button>
            </div>
        </div>
    );
};

const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
};

const modalStyle = {
    position: "relative",
    background: "#fff",
    color: "#000",
    padding: "2rem",
    borderRadius: "8px",
    width: "400px",
    maxWidth: "90vw",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
};

const closeButtonStyle = {
    position: "absolute",
    top: "0.75rem",
    right: "0.75rem",
    background: "none",
    border: "none",
    fontSize: "1.2rem",
    cursor: "pointer",
};

const fieldStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
};

const errorStyle = {
    color: "red",
    fontSize: "0.85rem",
};

export default ChangeProfilePic;